import { _ as __rest, a as __assign } from './tslib.es6-2259bcab.js';
import { c as classNames } from './index-444bb648.js';
import React__default, { createContext, useContext, useRef, useState, useMemo } from 'react';
import { C as ChevronRightIcon } from './ChevronRightIcon-6f867d25.js';
import './countries-4c9d3a3b.js';
import { C as Checkbox } from './index-745ad939.js';
import { a as useRowContext, u as useTableContext } from './RowContext-2d7a9636.js';
import { Tooltip, TooltipContent } from './es/components/Tooltip.js';

/**
 * Nesting Context is used to describe the nesting state to a row and it's children
 */
var NestingContext = createContext(undefined);
var useNestingContext = function () {
    var nestingContent = useContext(NestingContext);
    // If we're not under a nesting context, we default all nesting state to false to allow component to be used standalone
    if (nestingContent === undefined) {
        return { nested: false, open: false, setOpen: function () { return undefined; } };
    }
    return nestingContent;
};

var styles = {"cell":"TableCell_cell_ee5eab08","cellContainer":"TableCell_cellContainer_ee5eab08","hasNesting":"TableCell_hasNesting_ee5eab08","nesting":"TableCell_nesting_ee5eab08","nestingClosed":"TableCell_nestingClosed_ee5eab08","cellCheckbox":"TableCell_cellCheckbox_ee5eab08","cellNestExtraPadd":"TableCell_cellNestExtraPadd_ee5eab08","alignCenter":"TableCell_alignCenter_ee5eab08","alignRight":"TableCell_alignRight_ee5eab08"};

var TableCell = React__default.forwardRef(function TableCell(_a, ref) {
    var _b;
    var children = _a.children, className = _a.className, isFirstCell = _a.isFirstCell, align = _a.align, props = __rest(_a, ["children", "className", "isFirstCell", "align"]);
    var _c = useNestingContext(), nested = _c.nested, open = _c.open;
    var _d = useRowContext(), rowId = _d.rowId, name = _d.name;
    var _e = useTableContext(), isSelectable = _e.isSelectable, rowState = _e.rowState, onRowSelect = _e.onRowSelect, maxSelectionCount = _e.maxSelectionCount, hasNesting = _e.hasNesting, isSelectionDisabled = _e.isSelectionDisabled;
    var checkboxRef = useRef(null);
    var _f = useState(false), checkboxHovered = _f[0], setCheckboxHovered = _f[1];
    if (isSelectable && !rowId) {
        throw new Error("Row id's must be provided when using selectable table");
    }
    var checkboxChecked = useMemo(function () { return (rowState[rowId || ""] !== undefined ? rowState[rowId || ""] : false); }, [rowId, rowState]);
    var checkboxDisabled = useMemo(function () {
        if (maxSelectionCount &&
            !checkboxChecked &&
            Object.values(rowState).filter(function (v) { return v; }).length >= maxSelectionCount)
            return true;
        if (isSelectionDisabled) {
            return true;
        }
        return false;
    }, [checkboxChecked, maxSelectionCount, rowState, isSelectionDisabled]);
    var handleCheckboxMouseEnter = function () {
        setCheckboxHovered(true);
    };
    var handleCheckboxMouseLeave = function () {
        setCheckboxHovered(false);
    };
    return (React__default.createElement("td", __assign({}, props, { className: classNames(styles.cell, className), ref: ref }),
        React__default.createElement("div", { className: classNames(styles.cellContainer, hasNesting && styles.hasNesting, hasNesting && !nested && isFirstCell && styles.cellNestExtraPadd, (_b = {},
                _b[styles.alignCenter] = align === "center",
                _b[styles.alignRight] = align === "right",
                _b)) },
            nested && (React__default.createElement(ChevronRightIcon, { className: classNames(styles.nesting, !open && styles.nestingClosed) })),
            isSelectable && isFirstCell && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(Tooltip, { id: "default-tooltip", placement: "top", isOpen: checkboxHovered && checkboxDisabled && !isSelectionDisabled, content: React__default.createElement(TooltipContent, null,
                        "Cannot select more then ",
                        maxSelectionCount) },
                    React__default.createElement("div", null,
                        React__default.createElement(Checkbox, { id: "cell-cb-".concat(rowId), ref: checkboxRef, "data-testid": "table-cell-row-checkbox", checked: checkboxChecked, disabled: checkboxDisabled, variant: "small", checkClassName: styles.cellCheckbox, onMouseEnter: handleCheckboxMouseEnter, onMouseLeave: handleCheckboxMouseLeave, onChange: function () {
                                onRowSelect && onRowSelect(rowId || "", name);
                            } }))))),
            React__default.createElement("span", null, children))));
});

export { NestingContext as N, TableCell as T };
